import React from "react";
import ShippingAndDelivery from "../components/ShippingAndDelivery";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const ShippingAndDeliveryPage = () => {
  return (
    <>
      <BreadcrumbTwo title="Shipping & Delivery" />
      <ShippingAndDelivery />
    </>
  );
};

export default ShippingAndDeliveryPage;